import { createContext, useContext } from 'react';
import type { TransactionFromDocumentModalControllerState } from './useTransactionFromDocumentModalController';

export const TransactionFromDocumentModalContext =
	createContext<TransactionFromDocumentModalControllerState | null>(null);

export const useTransactionFromDocumentModalContext =
	(): TransactionFromDocumentModalControllerState => {
		const context = useContext(TransactionFromDocumentModalContext);
		if (!context) {
			throw new Error(
				'useTransactionFromDocumentModalContext must be used within TransactionFromDocumentModalContext.Provider'
			);
		}
		return context;
	};
